import { UseClientReportingPortal } from '../hooks/reporting/useClientReportingPortal/useClientReportingPortal';
import makeVarPersisted from '../utils/react/makeVarPersisted';

export const selectedOrganizationIdVar = makeVarPersisted<string | undefined>(undefined, 'selectedOrganizationId');
export const selectedAdAccountIdVar = makeVarPersisted<string | undefined>(undefined, 'selectedAdAccountId');
export const onboardingActiveVar = makeVarPersisted<boolean>(false, 'onboardingActive');
export const userAmsUserIdVar = makeVarPersisted<string | undefined>('', 'userAmsUserId');
export const isBaymaxEnabledVar = makeVarPersisted<boolean | undefined>(false, 'isBaymaxEnabled');
export const triggerToShowPopupNotification = makeVarPersisted<boolean>(true, 'triggerToShowPopupNotification');
export const selectedLineItemIsDisabledByPrepaymentStatus = makeVarPersisted<boolean>(
  false,
  'selectedLineItemIsDisabledByPrepaymentStatus'
);
export const majorAudienceListLineItemForm = makeVarPersisted<string[]>([], 'majorAudienceListLineItemForm');
export const clientReportingPortalVar = makeVarPersisted<UseClientReportingPortal>(
  {},
  'clientReportingPortalOrgAndAdvertiser'
);
